import { Navigate, useParams } from 'react-router-dom';
import AuthCookieHandler from '@/services/AuthCookieHandler';
import AdminLoginPage from '@/views/AdminLogin';

const AdminLoginPageWrapper = () => {
  const { id } = useParams<{ id: string }>();
  const authHandler = new AuthCookieHandler();

  if (authHandler.isAuthenticated()) {
    return <Navigate to={`/qr/${id}/admin`} replace />;
  }

  return <AdminLoginPage />;
};

export default AdminLoginPageWrapper;
